// Global styles for container
export const containerStyles = {
  maxWidth: {
    xs: "100%", // Full width on small screens
    md: "960px", // 960px on medium screens
    lg: "1280px", // 1280px on large screens
    xl: "1680px", // Custom width for extra large screens
  },
  margin: "0 auto",
  px: { xs: 2, sm: 3 }, // Padding
};
// br
export const mainBr = { display: { xs: "none", sm: "none", md: "block", lg: "block" } }


// span 
export const spainColor = {
  backgroundImage: "linear-gradient(90deg, #4450A5 0%, #EF2A1E 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontWeight: "bold",
}

// h1

export const h1 = { fontWeight: "bold", mb: 1, fontSize: { xs: "18px", sm: "40px", md: "45px", lg: "50px" }, color: "#1A2334" }

// h2

export const h2 = { fontWeight: "bold", mb: 1, fontSize: { xs: "20px", sm: "36px", md: "40px", lg: "45px" }, color: "#1A2334" }

// button
export const button = {
  backgroundImage: 'linear-gradient(90deg, #4450A5 0%, #EF2A1E 100%)',
  color: '#fff',
  fontWeight: 'bold',
  textTransform: 'none',
  fontSize: '16px',
  px: 3,
  pr: 6,
  height: '45px',
  borderRadius: '999px',
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  position: 'relative',
}
export const icon = {
  position: 'absolute',
  right: 8,
  width: 36,
  height: 36,
  backgroundColor: '#fff',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}